<template>
  <div>
    <v-app-bar color="primary" dark flat contextmenu="menu">
      <!-- <v-app-bar-nav-icon></v-app-bar-nav-icon> -->

      <v-app-bar-title>
        <router-link to="/">
          <v-img v-if="isAuthBedrock" src="/bedrock-logo-white.webp" width="115" contain></v-img>
          <v-img v-else src="/logo-white.svg" width="115"></v-img>
        </router-link>
      </v-app-bar-title>

      <v-spacer></v-spacer>
      <span text v-if="marketName != ''">
        <v-icon left>mdi-store</v-icon>
        {{ marketName || "..." }}
      </span>
      <!-- <v-divider vertical></v-divider> -->
      <v-btn text link :to="`/`">
        <v-icon>mdi-home</v-icon>
      </v-btn>

      <!--
      <v-btn text link :to="`/document`">
        <v-icon left>mdi-book</v-icon> คู่มือการใช้งาน
      </v-btn>

      <v-btn text link :to="`/settings`">
        <v-icon left>mdi-cogs</v-icon> การตั้งค่า
      </v-btn>-->

      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" text>
            <v-icon left>mdi-account</v-icon>
            {{ getFullName }}
          </v-btn>
        </template>
        <v-list>
          <v-list-item v-if="!isAuthBedrock" link @click="isUpdateUser = true">
            <v-list-item-title>
              {{ $t('account.edit_personal_profile') }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="!isAuthBedrock"
            link
            color="error"
            :disabled="isAuthBedrock"
            @click="changePasswordDialog(true)"
          >
            <v-list-item-title>
              {{ $t('account.change_password') }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item link color="error" @click="logout">
            <v-list-item-title class="red--text">
              {{ $t('account.logout') }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    <reset-password v-model="isChangePassword"></reset-password>
    <edit-user v-model="isUpdateUser"></edit-user>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ResetPassword from "./ResetPassword.vue";
import EditUser from "./EditUser.vue";
export default {
  components: { ResetPassword, EditUser },
  name: "AppBar",
  computed: {},
  data() {
    return {
      isChangePassword: false,
      isUpdateUser: false
    };
  },
  computed: {
    ...mapGetters({
      getFullName: "user/getFullName",
      isAuthBedrock: "user/isAuthBedrock"
    }),
    marketName() {
      if (this.$route.params.marketId)
        return this.$store.getters["markets/getMarketName"];
      else return "";
    }
  },
  props: {
    name: String
  },
  methods: {
    changePasswordDialog(status = true) {
      this.isChangePassword = status;
    },
    async logout() {
      this.$router.push("/auth/login");
      await this.$store.dispatch("user/logout");
    }
  }
};
</script>

<style lang="scss" scoped></style>
